import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Store, StoreQueryParams, DataUpdateStore } from "../types";

interface StoreState {
	storeList: Array<Store>;
	storeTotal: number;
	storeDetail: Store | null;
	loading: boolean;
}

const initialState: StoreState = {
	storeList: [],
	storeTotal: 0,
	storeDetail: null,
	loading: false,
};

export const storeSlice = createSlice({
	name: "store",
	initialState,
	reducers: {
		setListStore: (state, action) => {
			state.storeList = action.payload.data;
			state.storeTotal = action.payload.total;
		},
		setStoreDetail: (state, action) => {
			state.storeDetail = action.payload;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const selectStoreList = (state: RootState) => state.store.storeList;
export const selectStoreTotal = (state: RootState) => state.store.storeTotal;
export const selectStoreDetail = (state: RootState) => state.store.storeDetail;
export const selectLoading = (state: RootState) => state.store.loading;

export const { setListStore, setStoreDetail, setLoading } = storeSlice.actions;

// get list
export interface GetListStoreAsyncPayload {
	query: StoreQueryParams;
}
export const getListStoreAsync = createAction(
	"store/getListStoreAsync",
	(payload: GetListStoreAsyncPayload) => ({
		payload,
	}),
);

// get detail
export interface GetStoreDetailAsyncPayload {
	storeId: string | number;
}
export const getStoreDetailAsync = createAction(
	"store/getStoreDetailAsync",
	(payload: GetStoreDetailAsyncPayload) => ({
		payload,
	}),
);

// Create
export interface CreateStoreAsyncPayload {
	data: DataUpdateStore;
	onSuccess?: (storeRes?: Store) => void;
}
export const createStoreAsync = createAction(
	"store/createStoreAsync",
	(payload: CreateStoreAsyncPayload) => ({
		payload,
	}),
);

// update
export interface UpdateStoreAsyncPayload {
	storeId: string | number;
	data: DataUpdateStore;
}
export const updateStoreAsync = createAction(
	"store/updateStoreAsync",
	(payload: UpdateStoreAsyncPayload) => ({
		payload,
	}),
);

export default storeSlice.reducer;
